const MenuTooling = {
  getInitialMenuStates: (menuElements, parent = null) => {
    var menuStates = {};
    for(var i=0; i<menuElements.length; i++) {
      var menuElement = menuElements[i];
      if(menuElement.childs) {
        menuStates[menuElement.key] = {
          enabled:false, 
          active: false, 
          open: false,
          parent: parent
        };
        Object.assign(menuStates,MenuTooling.getInitialMenuStates(menuElement.childs,menuElement));
      }
      else {
        menuStates[menuElement.key] = {
          enabled:false, 
          active: false, 
          parent: parent,
          route: menuElement.route
        };
      }
    }
    return menuStates;
  },
  manageOpenState: (elementStates, targetKey) => {
    var itemState = elementStates[targetKey];    
    //if state not exist, return false
    if(typeof itemState === "undefined") {
      return false;
    }
                                  
    Object.keys(elementStates).forEach(function(key,index) {
      //Close all except the clicked target
      if(key!=targetKey) {
        elementStates[key].open = false;
      }
    });
    //for the clicked target invert the open state.
    itemState.open = itemState.open ? false : true;
    
    return true;
  },
  manageActiveState: (elementStates, targetKey) => {
    var itemState = elementStates[targetKey];    
    //if state not exist or the user click something already active, return false
    if(typeof itemState !== "undefined" && itemState.active) {
      return false;
    }

    Object.keys(elementStates).forEach(function(key,index) {
      //set everything in active false
      elementStates[key].active = false;
    });
    
    if(typeof itemState === "undefined") {
      return false;
    }
    //active element
    itemState.active = true;
    //if has a parent, activate too
    if(itemState.parent!=null) {
      elementStates[itemState.parent.key].active = true;
    }
    
    return true;
  },
  setActiveMenu: (elementStates, route) => {
    Object.keys(elementStates).forEach(function(key,index) {
      //set everything in active and open false
      elementStates[key].open = false;
      elementStates[key].active = false;
      //activate if route match (more than one can be activated,  but not ideal)
      if(elementStates[key].route == route) {
        elementStates[key].active = true;
        //if has parent, activate and open the parent
        if(elementStates[key].parent!=null) {
          elementStates[elementStates[key].parent.key].open = true;
          elementStates[elementStates[key].parent.key].active = true;
        }
      }
    });
  }
};

export default MenuTooling;


// WEBPACK FOOTER //
// ./source/tooling/menuTooling.js